"use client";

// import { FC, useCallback, useEffect, useState } from "react";
import { FC } from "react";
import Image from "next/image";
import Link from "next/link";

import NavItem from "@/components/nav-item/NavItem";
import ThemeButton from "@/components/theme-button/ThemeButton";
import MobileNav from "@/components/mobile-nav/MobileNav";

const Nav: FC = () => {
  // const [isScroll, setIsScroll] = useState(false);

  // const handleScroll = useCallback(() => {
  //   // const scrolled = window.scrollY;

  //   // console.log(window.pageYOffset);

  //   // setIsScroll(scrolled > 50);
  // }, []);

  // useEffect(() => {
  //   handleScroll();
  //   window.addEventListener("scroll", () => handleScroll, { passive: false });

  //   return () => window.removeEventListener("scroll", () => handleScroll);
  // }, [handleScroll]);

  return (
    <nav
      id="site-nav"
      className={`sticky z-10 top-0 flex items-center justify-between py-3 px-4 transition-all ease-linear backdrop-blur ${
        // isScroll ? "bg-slate-500/5 dark:bg-white/5" : "bg-transparent"
        "bg-secondary-light dark:bg-secondary-dark"
      }`}
    >
      <div className="ml-4 py-1">
        <Link className=" flex items-center " href="/">
          <div className="avatar mr-4">
            <div className="w-12">
              <Image
                className="rounded-full"
                alt="Ryan Boros. front end developer"
                src="/profile/rb-logo.png"
                layout="fill"
                objectFit="cover"
              />
            </div>
          </div>
          <div className="text-2xl text-highlight font-semibold">Rb.</div>
        </Link>
      </div>

      <div className="flex items-center mr-4">
        <div className="hidden md:flex">
          <NavItem link="/about" label="About" />
          <NavItem link="/projects" label="Projects" />
          <NavItem link="/demos" label="Demos" />
          <NavItem link="/resume" label="Resume" />
        </div>
        <div className="flex md:hidden">
          <MobileNav />
        </div>
        <ThemeButton />
      </div>
    </nav>
  );
};

export default Nav;
